import { useTranslation } from 'react-i18next'
import { Wizard, Text, Icon, useWizardContext, Link } from '@lounge-fe/ui-kit'
import { StepLayout } from '../StepLayout'
import { StepActions } from '../StepActions'
import { useLoungeFit } from '../useLoungeFit'

export const Confirmation = () => {
  const { t } = useTranslation()
  const { goto, next } = useWizardContext()
  const calculateLoungeFit = useLoungeFit()

  return (
    <Wizard.Step>
      {({ getValues }) => {
        const values = getValues()

        const items = [
          {
            label: values.currentBrand
              ? t('fitting_room.confirmation.are_not_a_lounger')
              : t('fitting_room.confirmation.are_a_lounger'),
            step: 1,
          },
          {
            label: t('fitting_room.confirmation.bra_size', {
              size: [values.bandSize, values.cupSize].join(''),
            }),
            step: 2,
          },
          {
            label: t('fitting_room.confirmation.bra_style', {
              style: values.preferences,
            }),
            step: 3,
          },
          {
            label: t('fitting_room.confirmation.bra_age', {
              months: values.braAge,
            }),
            step: 4,
          },
          {
            label: t('fitting_room.confirmation.bottoms_size', {
              size: values.bottomsSize,
            }),
            step: 9,
          },
        ]

        return (
          <StepLayout
            title={t('fitting_room.confirmation.title')}
            subtitle={
              <div className="flex justify-between">
                <Text>{t('fitting_room.confirmation.subtitle')}</Text>
                <Text className="flex-grow-1 whitespace-nowrap ml-8 md:ml-16">
                  {t('general.x_of_y', {
                    x: '1',
                    y: '2',
                  })}
                </Text>
              </div>
            }
            showProgress={false}
          >
            <div className="flex flex-col gap-y-4">
              {items.map((item, index) => (
                <div key={index} className="flex justify-between">
                  <div className="flex gap-x-4">
                    <Icon.Tick />
                    <Text>{item.label}</Text>
                  </div>
                  <Link
                    as="button"
                    className="underline font-regular"
                    onClick={() => goto(item.step)}
                  >
                    {t('action.edit')}
                  </Link>
                </div>
              ))}
            </div>
            <StepActions
              next={{
                onClick: (evt) => {
                  evt.preventDefault()
                  next({ loungeFit: calculateLoungeFit() })
                },
              }}
            />
          </StepLayout>
        )
      }}
    </Wizard.Step>
  )
}
